import React from 'react'
import { StyledCodeSkeleton } from "../UI/Elements";
export default () => (<div>
  <StyledCodeSkeleton />
</div>)



// WEBPACK FOOTER //
// ./src/components/loading/bundleLoading.js